export const setStoredValue = (
  key: string,
  newValue: string | number | null | undefined,
): boolean | null => {
  if (!newValue) return null;
  try {
    sessionStorage.setItem(key, String(newValue));
    return true;
  } catch (error) {
    console.error("Failed to store value:", error);
    return false;
  }
};

export const getStoredValue = (key: string): string | null => {
  try {
    const stored = sessionStorage.getItem(key);
    return stored || null;
  } catch (error) {
    console.error("Error retrieving value:", error);
    return null;
  }
};

export const clearStoredValue = (key: string): void => {
  sessionStorage.removeItem(key);
};
